<script setup lang="ts"></script>

<template>
  <router-view />
</template>

<style scoped lang="scss"></style>
